@file:OptIn(InternalResourceApi::class)

package portico.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/portico.composeapp.generated.resources/"

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_229_513_188)
internal val Res.drawable.ic_add: DrawableResource by lazy {
      DrawableResource("drawable:ic_add", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_add.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_030_279_521)
internal val Res.drawable.ic_alarm: DrawableResource by lazy {
      DrawableResource("drawable:ic_alarm", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_alarm.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-44_353_311)
internal val Res.drawable.ic_assignment: DrawableResource by lazy {
      DrawableResource("drawable:ic_assignment", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_assignment.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(483_513_543)
internal val Res.drawable.ic_check_circle: DrawableResource by lazy {
      DrawableResource("drawable:ic_check_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_check_circle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_112_979_058)
internal val Res.drawable.ic_document: DrawableResource by lazy {
      DrawableResource("drawable:ic_document", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_document.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_003_256_559)
internal val Res.drawable.ic_email: DrawableResource by lazy {
      DrawableResource("drawable:ic_email", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_email.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_058_626_997)
internal val Res.drawable.ic_home: DrawableResource by lazy {
      DrawableResource("drawable:ic_home", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_home.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_074_030_868)
internal val Res.drawable.ic_map: DrawableResource by lazy {
      DrawableResource("drawable:ic_map", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_map.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_306_847_351)
internal val Res.drawable.ic_notification: DrawableResource by lazy {
      DrawableResource("drawable:ic_notification", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_notification.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-103_070_969)
internal val Res.drawable.ic_route: DrawableResource by lazy {
      DrawableResource("drawable:ic_route", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_route.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-686_853_204)
internal val Res.drawable.ic_search: DrawableResource by lazy {
      DrawableResource("drawable:ic_search", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_search.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-899_390_215)
internal val Res.drawable.ic_tools: DrawableResource by lazy {
      DrawableResource("drawable:ic_tools", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_tools.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_606_664_245)
internal val Res.drawable.ic_truck: DrawableResource by lazy {
      DrawableResource("drawable:ic_truck", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_truck.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-782_382_901)
internal val Res.drawable.ic_warning: DrawableResource by lazy {
      DrawableResource("drawable:ic_warning", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_warning.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("ic_add", Res.drawable.ic_add)
  map.put("ic_alarm", Res.drawable.ic_alarm)
  map.put("ic_assignment", Res.drawable.ic_assignment)
  map.put("ic_check_circle", Res.drawable.ic_check_circle)
  map.put("ic_document", Res.drawable.ic_document)
  map.put("ic_email", Res.drawable.ic_email)
  map.put("ic_home", Res.drawable.ic_home)
  map.put("ic_map", Res.drawable.ic_map)
  map.put("ic_notification", Res.drawable.ic_notification)
  map.put("ic_route", Res.drawable.ic_route)
  map.put("ic_search", Res.drawable.ic_search)
  map.put("ic_tools", Res.drawable.ic_tools)
  map.put("ic_truck", Res.drawable.ic_truck)
  map.put("ic_warning", Res.drawable.ic_warning)
}
